import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";

import "./more-options-menu.css";
import { useSelector } from "react-redux";

export default function MoreOptionsMenu({
  labelIcon,
  menuItemsTop = [],
  menuItemsBottom = [],
  menuItemsIngDesk = [],
  onClick,
}) {
  const infoDisplay = useSelector((state) => state.infodisplay);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const isMonitoring = infoDisplay.infodisplay === "Monitorias";

  const hasMenuItemsTop =
    !!menuItemsTop && Array.isArray(menuItemsTop) && menuItemsTop.length > 0;

  const hasMenuItemsBottom =
    !!menuItemsBottom &&
    Array.isArray(menuItemsBottom) &&
    menuItemsBottom.length > 0;

  const isSeparatorActive = hasMenuItemsTop && hasMenuItemsBottom;

  const hasMenuItemsIngDesk =
    Boolean(menuItemsIngDesk) &&
    Array.isArray(menuItemsIngDesk) &&
    menuItemsIngDesk.length > 0;

  const isSeparatorOfIngDeskItemsActive =
    (hasMenuItemsTop || hasMenuItemsBottom) && hasMenuItemsIngDesk;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div className={`more-options-menu ${isMonitoring ? "black-theme" : ""}`}>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <div className="new-side-menu__first-container__more-options__main-icon stroke">
            {labelIcon}
          </div>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="right"
          transition
          disablePortal
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 20], // Verificação condicional
              },
            },
          ]}
          sx={{
            zIndex: 999,
            boxShadow: "0px 4px 4px 0px #00000040, 0px -1px 4px 0px #00000040",
            borderRadius: "16px",
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              timeout={0}
              style={{
                transformOrigin:
                  placement === "right" ? "left center" : "left bottom",
              }}
            >
              <Paper
                className={`more-options-menu-container ${
                  isMonitoring ? "black-theme" : ""
                }`}
                sx={{
                  minWidth: "316px",
                  boxShadow: "none",
                  borderRadius: "16px",
                  backgroundColor: isMonitoring ? "#37334c" : "#ffffff",
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "12px",
                    }}
                  >
                    <span className="more-option-menu__paper__title">Menu</span>

                    {hasMenuItemsTop &&
                      menuItemsTop.map((item, index) => {
                        return (
                          <div
                            key={`${item.id}--${index}`}
                            className={`more-option-menu__paper__menu-item ${
                              infoDisplay.infodisplay === item.id
                                ? "active"
                                : ""
                            }`}
                            onClick={(event) => {
                              const hasOnClick = !!onClick;
                              const hasHandleClick = !!item.handleClick;
                              if (hasHandleClick) {
                                item.handleClick();
                                handleClose(event);
                                return;
                              }
                              if (hasOnClick) {
                                onClick(item.id);
                              }
                              handleClose(event);
                            }}
                          >
                            <div
                              className={`more-option-menu__paper__menu-item__icon ${item.iconFill}`}
                            >
                              {item.icon}
                            </div>
                            <span className="more-option-menu__paper__menu-item__label">
                              {item.label}
                            </span>
                          </div>
                        );
                      })}

                    {isSeparatorActive && (
                      <div className="more-option-menu__paper__separator">
                        <div className="more-option-menu__paper__separator__dash" />
                      </div>
                    )}

                    {hasMenuItemsBottom &&
                      menuItemsBottom.map((item, index) => {
                        return (
                          <div
                            key={`${item.id}--bottom--${index}`}
                            className={`more-option-menu__paper__menu-item ${
                              infoDisplay.infodisplay === item.id
                                ? "active"
                                : ""
                            }`}
                            onClick={(event) => {
                              const hasOnClick = !!onClick;
                              const hasHandleClick = !!item.handleClick;
                              if (hasHandleClick) {
                                item.handleClick();
                                handleClose(event);
                                return;
                              }
                              if (hasOnClick) {
                                onClick(item.id);
                              }
                              handleClose(event);
                            }}
                          >
                            <div
                              className={`more-option-menu__paper__menu-item__icon ${item.iconFill}`}
                            >
                              {item.icon}
                            </div>
                            <span className="more-option-menu__paper__menu-item__label">
                              {item.label}
                            </span>
                          </div>
                        );
                      })}

                    {isSeparatorOfIngDeskItemsActive && (
                      <div className="more-option-menu__paper__separator">
                        <div className="more-option-menu__paper__separator__dash" />
                      </div>
                    )}

                    {hasMenuItemsIngDesk &&
                      menuItemsIngDesk.map((item, index) => {
                        return (
                          <div
                            key={`${item.id}--bottom--${index}`}
                            className={`more-option-menu__paper__menu-item ${
                              infoDisplay.infodisplay === item.id
                                ? "active"
                                : ""
                            }`}
                            onClick={(event) => {
                              const hasOnClick = !!onClick;
                              const hasHandleClick = !!item.handleClick;
                              if (hasHandleClick) {
                                item.handleClick();
                                handleClose(event);
                                return;
                              }
                              if (hasOnClick) {
                                onClick(item.id);
                              }
                              handleClose(event);
                            }}
                          >
                            <div
                              className={`more-option-menu__paper__menu-item__icon ${item.iconFill}`}
                            >
                              {item.icon}
                            </div>
                            <span className="more-option-menu__paper__menu-item__label">
                              {item.label}
                            </span>
                          </div>
                        );
                      })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
